import { FC } from 'react';
import Select from '../select';
import { FormProps } from '../helpers';
import { UiOption } from '@/lib/helpers';

interface Props extends FormProps {
  value: boolean | undefined;
  onChange: (value: boolean | undefined) => void;
  options?: UiOption[];
}

const getBooleanValue = (value: string | undefined): boolean | undefined => {
  if (value === undefined) {
    return undefined;
  }

  return value === 'enabled';
};

const BooleanOpts: UiOption[] = [
  { label: 'Enabled', value: 'enabled' },
  { label: 'Disabled', value: 'disabled' },
];

const getStringValue = (value: boolean | undefined): string | undefined => {
  if (value === undefined) {
    return undefined;
  }

  return value ? 'enabled' : 'disabled';
};

const BooleanSelect: FC<Props> = ({ value, onChange, options = BooleanOpts, ...rest }) => {
  const handleChange = (value: string) => {
    onChange(getBooleanValue(value));
  };

  const props = {
    ...rest,
    value: getStringValue(value),
    onChange: handleChange,
    options,
  };

  return <Select {...props} />;
};

export default BooleanSelect;
